import React from "react";
import "../components/styles/PrivacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <div className="content">
      <h1>Privacy Policy for Smart Clinic</h1>
      {/* <p><strong>Last updated:</strong> [DATE]</p> */}

      <p>
        Siara PVT LTD (“we”, “our”, “us”) operates the Smart Clinic mobile application.
        This Privacy Policy explains how we collect, use, store, and protect your
        personal information when you use the App.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We collect the following types of information:</p>

      <h3>Personal Information</h3>
      <ul>
        <li>Name</li>
        <li>Email</li>
        <li>Phone Number</li>
        <li>Address</li>
        <li>Profile Photos</li>
      </ul>

      <h3>Medical & Sensitive Information</h3>
      <ul>
        <li>Health records</li>
        <li>Medical history</li>
        <li>Appointment details</li>
      </ul>

      {/* <h3>Technical Information</h3>
      <ul>
        <li>Device information</li>
        <li>Crash logs</li>
      </ul> */}

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To create and manage your Smart Clinic account</li>
        <li>To manage medical appointments</li>
        <li>To store and allow access to medical records</li>
        <li>To send notifications</li>
      </ul>

      <h2>3. How Your Data Is Stored</h2>
      <p>Your data is securely stored in:</p>
      <ul>
        <li>Firebase Authentication</li>
        <li>Firebase Firestore</li>
        <li>FastAPI backend (only for notifications)</li>
      </ul>

      {/* <h2>4. Data Sharing</h2>
      <p>
        We may share certain personal information, such as your email address and phone number, with trusted partners for medical campaigns and related services.
        We do not sell your data to advertisers or other unrelated third parties. All shared data is handled in accordance with applicable privacy laws and is used only for purposes you have consented to.
      </p> */}

      <h2>4. Data Security</h2>
      <p>
        We use encryption, secure Firebase rules, and role-based access to protect your
        data. We work hard to safeguard your information.
      </p>

      <h2>5. User Rights</h2>
      <p>You may request account deletion, data access, or data correction at any time.</p>
      <p>Contact: <strong>smartclinicnetwork@gmail.com</strong></p>

      <h2>6. Children's Privacy</h2>
      <p>We do not knowingly collect information from children under 13.</p>

      <h2>7. Changes to This Policy</h2>
      <p>We may update this policy and will post changes here.</p>

      <h2>8. Contact Us</h2>
      <p><strong>Company:</strong> Siara PVT LTD</p>
      <p><strong>Email:</strong> siaramarketingpvtltdofficial@gmail.com</p>
    </div>
  );
}
